import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { EzidebitCardPage } from './ezidebit-card.page';

const routes: Routes = [
  {
    path: '',
    component: EzidebitCardPage,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class EzidebitCardPageRoutingModule {}
